<template>
  <div class="menu">
    <div class="menu__list">
      <template v-for="(item, index) in data">
        <div class="menu__item links-items" v-if="item.items" :key="index">
          <div>{{ item.label }}</div>
          <template v-for="(linkItem, linkItemIndex) in item.items">
            <template v-if="linkItemIndex > 0"> | </template>
            <router-link
              class="menu__item-link"
              :to="linkItem.name"
              @click.native="emitHideMenu"
              :key="linkItemIndex"
            >
              {{ linkItem.label }}
            </router-link>
          </template>
        </div>
        <div class="menu__item" v-else-if="item.showItem && !item.children"  :key="index">
          <router-link
            class="menu__item-link"
            :to="item.name"
            @click.native="emitHideMenu"
          >
            {{ item.label }}
          </router-link>
        </div>
        <div class="menu__item"
             :key="index"
             v-else-if="item.showItem && item.children"
        >
          <div
            class="menu__list"
          >
            <div class="menu__item">
              <span
                class="menu__item-link"
                @click.prevent="toggleShowModal(item.name)"
              >
                {{ item.label }}
              </span>
            </div>
            <MenuChild
              class="menu__child"
              v-if="menu.showItem === item.name"
              :data="item.children"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
const MenuChild = () => import('@components/Menu/MenuChild.vue')

export default {
  components: { MenuChild },
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      menu: {
        showItem: false
      }
    }
  },
  created () {
    this.$event.$on('menu-hide', this.hideMenu)
  },
  methods: {
    emitHideMenu () {
      this.$event.$emit('menu-hide')
    },
    hideMenu () {
      this.menu.showItem = false
    },
    toggleShowModal (name) {
      if (this.menu.showItem === name) {
        this.menu.showItem = false
        return
      }

      this.menu.showItem = name
    }
  },
  beforeDestroy () {
    this.$event.$off('menu-hide', this.hideMenu)
  }
}
</script>

<style scoped lang="scss">
  .links-items {
    white-space: nowrap;
    a {
      display: inline;
    }
  }
</style>
